<template>


  <t-dialog-form :generalErrors="generalErrors" large :title="t(command) + ' Ambiente'"
                 tabs
                 :ok-text="t(command) + ' Ambiente'" @show="showModal" @hidden="onClose" :busy="busy" :id="id"
                 :status="status" :command="command" :set-tab-index="tabIndex"
                 ref="dialog_form" @onSubmit="onSubmit">

    <template #default>

      <t-form-tab title="Dados Básicos" class="border">

        <t-input v-model="form.environmentId" hidden/>

        <b-card-title>Pavimento: {{ spotFolder }}</b-card-title>

        <b-row>

          <t-input v-model="form.name" cols="6" :add-error="error.name" label="Ambiente" required/>

          <t-input
              v-if="!form.enableSpecificItems"
              v-model="form.typeEnvironmentId"
                   :options="typeEnvironmentOptions"
                   cols="5"
                   @change="changeTypeEnvironment"
                   label="Modelo de Ambiente" select required>

            <b-link v-if="form.typeEnvironmentId>0" target="_blank" :href="linkTypeEnvironment">Detalhar itens do modelo</b-link>

          </t-input>


          <!--          <t-input v-model="form.environmentCodeLabel"
                             v-if="modeCodeLabel === SettingType.mode.MODE_CODE_LABEL_MANUAL"
                             :add-error="error.environmentCodeLabel" upper cols="2"
                             label="Cód. Ambiente"
                             help="Código inserido manualmente conforme configurado em Locais > Configurações > Parâmetros"
                             required/>


                    <t-input v-model="form.environmentCodeLabel"
                             v-else-if="modeCodeLabel === SettingType.mode.MODE_CODE_LABEL_AUTOMATIC_DEFAULT"
                             :add-error="error.environmentCodeLabel" upper cols="2"
                             fixed
                             label="Cód. Ambiente"
                             help="Código inserido automaticamente conforme configurado em Locais > Configurações > Parâmetros"
                    />-->


        </b-row>

        <!--
        <t-input v-model="foSrm.createdSortedAfterEnvironmentId" label="createdSortedAfterEnvironmentId" number />
        -->

        <t-input v-model="form.note" label="Observações" max-length="500" textarea/>

        <b-form-checkbox class="mb-2"
                         v-model="form.enableSpecificItems" switch>
          Utilizar mapeamento especifico para este ambiente?
          <t-help
              title="Utilize esta opção para escolhar quais os itens desejados."/>
        </b-form-checkbox>

<!--        <b-form-checkbox v-if="enableSharingPublic" class="mb-2"
                         v-model="form.sharingEnable" switch>
          Habilitar acesso externo deste ambiente através de URL?
          <t-help
              title="Utilize esta opção para possibilitar o acesso externo a este ambiente especificamente, possibilitando a visualização de apontamentos deste ambiente, porém somente irá funcionar se o local relacionado diretamente a este ambiente estiver também habilitado para acesso via URL, caso contrário não irá funcionar."/>
        </b-form-checkbox>

        <b-form-checkbox v-else class="mb-2" disabled v-model="form.sharingEnable" switch>
          (Desabilitado por política global) Habilitar acesso externo deste ambiente através de URL?
          <t-help
              title="Desabilitado a opção de compartilhamento através de Qr-code por conta da política global, caso desejar alterar solicita a um usuário administrador."/>
        </b-form-checkbox>-->

        <t-input-status v-model="form.status"/>

      </t-form-tab>

<!--      <t-form-tab title="Detalhes" class="border">

        <t-msg v-if="form.typeEnvironmentId === 0" info>
          Selecione um tipo de ambiente na aba 'Dados Básicos' para
          especificar detalhes para este ambiente
        </t-msg>


        <t-msg v-else-if="spotSpecificationList.length === 0 && spotDetailsList.length === 0" info>
          Utilize o cadastro de especificações e detalhes através do módulo 'Mapeamento' > 'Configurações'
          possibilitando
          cadastros detalhados dos ambientes.
        </t-msg>


        <div v-if="spotSpecificationList.length > 0" class="mt-3">
          <b-card-title>Especificação</b-card-title>

          <t-table
              enable-radio
              class="mb-2"
              v-model="form.spotSpecificationId"
              :items="spotSpecificationList"
              :fields="viewFieldsPageSpotSpecification"
              title-items="Especificação"
              link-primary-column="name"
              table-bordered
              disable-actions-column
              primary-key-column="spotSpecificationId">

            <template #first-column="{item}">
              {{ item.name }}
            </template>

          </t-table>

          <b-link v-if="form.spotSpecificationId > 0" @click="form.spotSpecificationId = 0" class="font-italic">Limpar
            Especificação
          </b-link>

        </div>

        <div v-if="spotDetailsList.length > 0" class="mb-2 mt-4">

          <b-card-title>Detalhes</b-card-title>

          <t-table
              enable-checked
              v-model="spotDetailsIds"
              :items="spotDetailsList"
              :fields="viewFieldsPageSpotDetail"
              title-items="detalhes"
              link-primary-column="name"
              table-bordered
              disable-actions-column
              primary-key-column="spotDetailId">

            <template #first-column="{item}">
              {{ item.name }}
            </template>

          </t-table>

        </div>

      </t-form-tab>-->

    </template>

    <template #out-of-form>

      <t-form-tab title="Itens" v-if="form.enableSpecificItems" hash="item" lazy>
        <EnvironmentItem :foreign-key="form.environmentId"/>
      </t-form-tab>

      <t-form-tab title="Planta Ambiente" v-if="accountModule !== 'estate'" class="border"
                  :disabled="!relationAccessPageGeneral('place-environment-file')"
                  lazy>

        <EnvironmentFile type-unique-image category-unique="FP" detail-unique="Planta Baixa"
                         :foreign-key="form.environmentId"/>


      </t-form-tab>

      <t-form-tab title="Arquivos" v-if="accountModule !== 'estate'"  class="border" :disabled="!relationAccessPageGeneral('place-environment-file')"
                  lazy>

        <t-form-card class="border" title="Imagens">
          <EnvironmentFile type-image :foreign-key="form.environmentId"/>
        </t-form-card>

        <t-form-card class="border" title="Arquivos">
          <EnvironmentFile :foreign-key="form.environmentId"/>
        </t-form-card>

      </t-form-tab>

      <t-form-tab title="Comentários" class="border" :disabled="validationCommentOption === 0" lazy>
        <Comment :foreign-key="userAuth.currentPage.pageId" :relation-key="form.environmentId"
                 enable-sharing
                 disabled-category
                 disabled-keyword/>
      </t-form-tab>



    </template>

  </t-dialog-form>


</template>
<script>
import tDialogForm from "@/components/template/dialog/t-dialog-form";
import pageDialogFormMixin from "@/mixins/page/pageDialogFormMixin";
import SettingType from "@/model/types/resource/SettingType";
import pageViewService from "@/services/modules/setting/PageView.service";
import SpotSpecificationService from "@/services/modules/place/SpotSpecification.service";
import SpotDetailService from "@/services/modules/place/SpotDetail.service";
import TypeEnvironmentService from "@/services/modules/place/TypeEnvironment.service";
import Comment from "@/views/modules/general/Comment";
import EnvironmentFile from "@/views/modules/place/EnvironmentFile";
import ui from "@/assets/scripts/ui";
import EnvironmentItem from "@/views/modules/place/EnvironmentItem";
export default {
  name: 'EnvironmentDialog',
  components: {tDialogForm, Comment, EnvironmentFile, EnvironmentItem},
  mixins: [pageDialogFormMixin],
  data() {
    return {
      SettingType,
      id: "modal-place-environment",
      path: "place/environment", //Utilizar somente quando fora do padrão
      primaryKeyColumn: "environmentId",
      foreignKeyColumn: "spotFolderId", //Utilizar quando usar Tabs com outros componentes
      genKey: true, //Utilizar quando desejar gerar chave temporária
      enableGeneralFields: false,
      tabIndex: 0,
      form: {
        environmentId: this.primaryKey,
        environmentNumber: 0,
        environmentCodeLabel: "",
        spotFolderId: this.foreignKey,
        createdSortedAfterEnvironmentId: 0,
        typeEnvironmentId: 0,
        spotSpecificationId: 0,
        enableSpecificItems:false,
        sharingEnable: true, /*Por padrão estará habilitado, porém somente funciona se o local relacionado diretamente estiver habilitado também.*/
        name: "",
        note: "",
        status: 1,
        spotDetails: [],
      },
      error: {//Campos que podem receber retorno de erro do backend
        spotFolderCodeLabel: "",
        typeSpotFolderId: "",
        name: ""
      },
      fieldsNotReset: [//Marca os nomes de colunas que não devem ser resetados
        this.foreignKeyColumn,
      ],
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      accountModule: "",
      modeCodeLabel: "",
      spotDetailsIds: [],
      spotDetailsList: [],
      spotSpecificationList: [],
      viewFieldsPageSpotDetail: [],
      viewFieldsPageSpotSpecification: [],
      typeEnvironmentOptions: [],
      validationCommentOption: 0,
      linkTypeEnvironment: "",
    }
  },
  props: {
    enableSharingPublic: Boolean,/*Política global geral*/
    setTabIndex: {
      type: Number,
      default: 0,
    },
    spotFolder: String,
  },
  methods: {

    async mountedContinued() {

      this.modeCodeLabel = this.getRenderRule(SettingType.render.RENDER_TAG_COD_LABEL)

      await pageViewService.getViewFieldsByPage(198, true, ["typeEnvironments"]).then((response) => {
        this.viewFieldsPageSpotDetail = response
      }).catch(error => this.responseError(error))

      await pageViewService.getViewFieldsByPage(199, true, ["typeEnvironments"]).then((response) => {
        this.viewFieldsPageSpotSpecification = response
      }).catch(error => this.responseError(error))


      await TypeEnvironmentService.selectList().then((list) => {
        this.typeEnvironmentOptions = list
      }).catch(error => this.responseError(error))



      this.pageFormIsLoaded = true


    },

    //Declaro sempre localmente, pois poderá realizar operações diferentes do padrão como setar algum valor padrão vindo de fora e que seria limpo pelo resetModal de forma dinamica
    async showModal() {

      this.busy = true

      //Limpa os campos
      this.resetModal()

      this.accountModule = ui.getAccountModule()

      //Setar alguma informações padrão por exemplo vindo de fora
      this.form.environmentId = this.primaryKey
      this.form.spotFolderId = this.foreignKey
      this.form.status = 1
      this.form.enableSpecificItems = false

      if (this.enableSharingPublic) {
        this.form.sharingEnable = true
      } else {
        this.form.sharingEnable = false
      }


      if(this.accountModule === 'estate'){
        //Módulo imobiliário por padrão virá com especificação dos itens
        this.form.enableSpecificItems = true
      }

      this.validationCommentOption = this.getRenderRule('validationCommentOption')

      await this.readModal(true)

      await this.changeTypeEnvironment()

      //Volta para aba inicial por padrão
      this.tabIndex = this.setTabIndex

    },


    async onSubmit() {

      this.form.spotDetails = this.convertArrayIdsToObject(this.spotDetailsIds, "spotDetailId")

      //Validações específicas da tela
      await this.setSubmitDialogDefault()


    },

    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    async changeTypeEnvironment() {

      this.spotDetailsList = []
      this.spotSpecificationList = []

      if (this.form.typeEnvironmentId > 0) {

        await SpotDetailService.getSpotDetailsByTypeEnvironment(this.form.typeEnvironmentId).then((list) => {
          this.spotDetailsList = list
          this.spotDetailsIds = this.convertObjectToArrayIds(this.form.spotDetails, "spotDetailId")
        }).catch(error => this.responseError(error))

        await SpotSpecificationService.getSpotSpecificationsByTypeEnvironment(this.form.typeEnvironmentId).then((list) => {
          this.spotSpecificationList = list
        }).catch(error => this.responseError(error))


        this.linkTypeEnvironment = ""

        await TypeEnvironmentService.getById(this.form.typeEnvironmentId).then((response) => {
          this.linkTypeEnvironment = "/place/type-environment/" + response.data.typeEnvironmentNumber + "#item"
        }).catch(error => this.responseError(error))

      }

    },
    //--------------------------------------------------------------------------------------
  },
  watch: {
    setTabIndex(value) {
      this.tabIndex = value
    },
  }
}
</script>
